var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "campaigns") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-dashboard1",
    transform: "translate(-38.000000, -312.000000)",
    fill: "#585555",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(38.000000, 312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "campaigns"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000168539326,8.36370787 C-0.0107865169,9.31573034 0.576067416,10.1725281 1.46769663,10.5063483 L1.46769663,6.42657303 C1.46769663,6.36786517 1.49702247,6.27983146 1.49702247,6.2211236 C0.599382022,6.55224719 0.00235955056,7.40685393 0.000168539326,8.36370787 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01297753,13.4120787 L4.16797753,13.4120787 L5.60617978,18.636573 C5.8191573,19.4338764 6.54196629,19.9880337 7.36724719,19.9867416 C7.9544382,19.9937079 8.51,19.7213483 8.8641573,19.2529775 C9.22174157,18.8073596 9.33202247,18.2121348 9.15764045,17.6680337 L8.01297753,13.4120787 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50755169,6.22503258 L1.55975169,6.22503258 L1.55975169,6.17283258 C1.55975169,6.22503258 1.55975169,6.22503258 1.50755169,6.22503258 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5417978,5.78078652 L22.3069663,5.78078652 L22.3069663,11.0639888 L22.5417978,11.0639888 C24.0007303,11.0639888 25.1833708,9.88129213 25.1833708,8.42241573 C25.1833708,6.96348315 24.0006742,5.78078652 22.5417978,5.78078652 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34825843,6.42651685 L2.34825843,10.594382 C2.38,11.6737079 3.26438202,12.5320225 4.34410112,12.5315732 L9.68601124,12.5315732 L9.68601124,4.60674157 L4.34410112,4.60674157 C3.28747191,4.60674157 2.34825843,5.36988764 2.34825843,6.42651685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.5665169 12.6489326 21.4264045 16.9929213 21.4264045 0.0279775281 10.5665169 4.37196629"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.f248f8759527cefbce019816b2402187.svg";
export { ForwardRef as ReactComponent };